/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { BillingStateEnum } from './billingStateEnum';
import { BillingModeEnum } from './billingModeEnum';
import { BucketModeEnum } from './bucketModeEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface BillingEntityPostSpec { 
    billing_mode?: BillingModeEnum;
    billing_state?: BillingStateEnum;
    /**
     * AWS Account number for usage files storage bucket
     */
    bucket_account?: string;
    bucket_mode?: BucketModeEnum;
    /**
     * Bucket Name of usage files storage
     */
    bucket_name?: string;
    /**
     * Count of register and deregister cycles
     */
    generation_count?: number;
    cloud_provider?: CloudProviderEnum;
    /**
     * Start timestamp of this billing entity generation
     */
    start_ts?: Date;
    /**
     * End timestamp of this billing entity generation (null if active)
     */
    end_ts?: Date;
    /**
     * Reference to the event_history record that created this generation
     */
    event_history_id?: number;
    entity_uuid: string;
    org_id: string;
    service_type: ServiceTypeEnum;
    vcds_service_type: VcdsServiceTypeEnum;
}
export namespace BillingEntityPostSpec {
}


